/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  GetUserResultPaginatedResult,
  LogInRequest,
  ProblemDetails,
  UserResult
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class User<
  SecurityDataType = unknown
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags User
   * @name UserCreate
   * @request POST:/user
   * @secure
   */
  userCreate = (data: LogInRequest, params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/user`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags User
   * @name UserList
   * @request GET:/user
   * @secure
   */
  userList = (
    query?: {
      /**
       * @format int32
       * @min 0
       * @max 2147483647
       * @default 0
       */
      pageNo?: number;
      /**
       * @format int32
       * @min 1
       * @max 50
       * @default 50
       */
      perPage?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<GetUserResultPaginatedResult, string | ProblemDetails>({
      path: `/user`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags User
   * @name CurrentList
   * @request GET:/user/current
   * @secure
   */
  currentList = (params: RequestParams = {}) =>
    this.request<UserResult, ProblemDetails>({
      path: `/user/current`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags User
   * @name Auth0Create
   * @summary Adds a user via Auth0 authentication.
   * @request POST:/user/auth0
   * @secure
   */
  auth0Create = (params: RequestParams = {}) =>
    this.request<void, ProblemDetails>({
      path: `/user/auth0`,
      method: "POST",
      secure: true,
      ...params
    });
  /**
   * No description
   *
   * @tags User
   * @name UserDetail
   * @summary Gets a user via Auth0Id.
   * @request GET:/user/{authId}
   * @secure
   */
  userDetail = (authId: string, params: RequestParams = {}) =>
    this.request<void, ProblemDetails>({
      path: `/user/${authId}`,
      method: "GET",
      secure: true,
      ...params
    });
}
